import { render, staticRenderFns } from "./data_details.vue?vue&type=template&id=5e7aafcc&scoped=true&"
import script from "./data_details.vue?vue&type=script&lang=js&"
export * from "./data_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7aafcc",
  null
  
)

export default component.exports